export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-13',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
